import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import { createPopper } from "@popperjs/core";

const IndexDropdown = () => {
  // dropdown props
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-start",
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };
  return (
    <>
    <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">
    <li className="flex items-center">
   
    <Link
          to="/"
          className="hover:text-gray-600 text-gray-800 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
        >
        Home
      </Link>
      </li>
      <li className="flex items-center">
      <Link
          to="/About#about"
          className="hover:text-gray-600 text-gray-800 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
        >
        About us
      </Link>
      </li>
      <li className="flex items-center">
      <a
        className="hover:text-gray-600 text-gray-800 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold overflow-auto"
        href="#pablo"
        
        ref={btnDropdownRef}
        onClick={(e) => {
          e.preventDefault();
          dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
        }}
      >
        SERVICES
      </a>
      <div style={{maxHeight:'400px',overflowY:'scroll'}}
        ref={popoverDropdownRef}
        className={
          (dropdownPopoverShow ? "block " : "hidden ") +
          "bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
        }
      >
        <span
          className={
            "text-sm pt-2 pb-0 px-4 font-bold block w-full whitespace-no-wrap bg-transparent text-gray-500"
          }
        >
          Mobile APP Development
        </span>
        <Link
          to="/Flutter#flutter"
          className="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800"
        >
          Flutter Development
        </Link>
        <Link
          to="/Android#android"
          className="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800"
        >
          Android Development
        </Link>
        <Link
          to="/Ios#ios"
          className="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800"
        >
          iOS Development
        </Link>
        <Link
          to="/MobileApp#mobile"
          className="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800"
        >
          Mobile App Development 
        </Link>
        <Link
          to="/Ionic#ionic"
          className="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800"
        >
          Ionic App Development 
        </Link>
        <Link
          to="/ReactNative#React"
          className="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800"
        >
         React Native Development
        </Link>
        <div className="h-0 mx-4 my-2 border border-solid border-gray-200" />
        <span
          className={
            "text-sm pt-2 pb-0 px-4 font-bold block w-full whitespace-no-wrap bg-transparent text-gray-500"
          }
        >
         Web Development
        </span>
        <Link
          to="/Reactjs#js"
          className="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800"
        >
        ReactJS Development
        </Link>
        <Link
          to="/Angular#angular"
          className="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800"
        >
          AngularJS Development
        </Link>
        <Link
          to="/Wordpress#wordpress"
          className="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800"
        >
          WordPress Development
        </Link>
        <Link
          to="/Node#node"
          className="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800"
        >
          NodeJS Development
        </Link>
        <Link
          to="/PHP#php"
          className="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800"
        >
          PHP Development
        </Link>
        <Link
          to="/Python#python"
          className="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800"
        >
         Python Development
        </Link>
        <Link
        to="/Laravel#lara" class="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800">
          Laravel Development
        </Link>
        <Link
        to="/CI#ci" class="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800">
          Codeigniter Development
        </Link>
        {/* <div className="h-0 mx-4 my-2 border border-solid border-gray-200" />
        {/* <span
          className={
            "text-sm pt-2 pb-0 px-4 font-bold block w-full whitespace-no-wrap bg-transparent text-gray-500"
          }
        >
         WordPress Development
        </span> */}
        
      </div>
      </li>
      <li className="flex items-center">
      <Link
          to="/"
          className="hover:text-gray-600 text-gray-800 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
        >
        Blog
      </Link>
      </li>
      <li className="flex items-center">
      <Link
          to="/Career#cara"
          className="hover:text-gray-600 text-gray-800 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
        >
        Career
      </Link>
      </li>
      </ul>
    </>
  );
};

export default IndexDropdown;
